import AnalyticsData from '@atlassian/jira-analytics-web-react/src/components/analytics-data.tsx';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { ANALYTIC_CONTEXTS } from '@atlassian/jira-servicedesk-common/src/utils/analytics';
import AutomationSummaryV2 from './view';

const SummaryAppWithAnalytics = AnalyticsSource(
	'viewAutomationSettings',
	SCREEN,
)(
	AnalyticsData({
		attributes: {
			context: ANALYTIC_CONTEXTS.AUTOMATION_SETTINGS,
		},
	})(AutomationSummaryV2),
);

export default SummaryAppWithAnalytics;
